<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      flat
      height="100"
      class="container pl-0 pr-0 pb-0"
    >
      <div class="media-exit__header-logo-image">
        <img
          class="header-logo"
          src="../../assets/images/Media_Exit_0419.png"
          alt="media-exit"
        />
      </div>
    </v-app-bar>
    <v-container>
      <v-content>
        <div>
          <div class="media-exit__receiver">
            <div class="media-exit__receiver-name">
              <p>
                <span class="font-weight-bold">{{
                  receiverFilesData.email_from
                }}</span>
                sent you {{ receiverFilesData.number_of_files }} files on
                {{
                  moment(receiverFilesData.ordered_date).format("DD MMM YYYY")
                }}
              </p>
            </div>
            <hr class="mb-5" />
            <div class="media-exit__receiver-subject-message">
              <p class="media-exit__receiver-subject">
                <v-row class="no-gutters">
                  <v-col col="4" md="1"
                    ><span class="font-weight-bold mr-2">Subject:</span></v-col
                  >
                  <v-col col="8" md="11">{{ receiverFilesData.subject }}</v-col>
                </v-row>
                <v-row>
                  <v-col col="4" md="1"
                    ><span class="font-weight-bold mr-2">Message:</span></v-col
                  >
                  <v-col col="8" md="11">{{ receiverFilesData.message }}</v-col>
                </v-row>
              </p>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <div class="media-exit__receiver__download-files">
                <div class="media-exit__receiver__img-title mt-4">
                  <v-row
                    class="no-gutters mt-5"
                    v-for="(filestatus,
                    index) in receiverFilesData.ordered_items"
                    :key="filestatus"
                  >
                    <v-col cols="8" class="d-flex">
                      <div>
                        <img
                          class="float-left mr-3"
                          src="../../assets/images/file.svg"
                          alt="file icon"
                        />
                      </div>
                      <div class="media-exit__receiver-fileinfo">
                        <h4 class="word-break-all receiver-file-name">
                          {{ filestatus.s3file.file_name }}
                        </h4>
                        <p class="word-break-all receiver-desc">
                          Expiry Date:
                          {{
                            moment(filestatus.expiry_date).format("DD MMM YYYY")
                          }}
                          |
                          {{ filestatus.s3file.file_size | fileSizeConverter }}
                        </p>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div
                        class="
                          media-exit__receiver-status
                          float-right
                          receiver-status-btn
                        "
                      >
                        <div class="text-right mb-5">
                          <v-chip
                            :style="{
                              'background-color':
                                filestatus.downloads_remaining === 0
                                  ? '#CB4A5F'
                                  : getColor(filestatus.file_status.status)
                            }"
                            :class="[
                              (filestatus.file_status.status =
                                filestatus.downloads_remaining === 0 &&
                                filestatus.file_status.status === 'Active'
                                  ? 'Max Limit Reached'
                                  : filestatus.file_status.status)
                            ]"
                            :disabled="isButtonActive"
                            text-color="white"
                            >{{
                              filestatus.file_status.status | capitalize
                            }}</v-chip
                          >
                        </div>
                        <p>
                          <strong
                            >{{ filestatus.downloads_remaining }}
                            {{ downloadText }}</strong
                          >
                          <v-btn
                            :ripple="false"
                            :disabled="
                              filestatus.disable_download ||
                                filestatus.downloads_remaining === 0 ||
                                filestatus.file_status.status === 'Cancelled' ||
                                filestatus.file_status.status === 'Expired' ||
                                filestatus.file_status.status === 'Restoring'
                            "
                            class="receiver-download-btn"
                          >
                            <img
                              id="test"
                              :style="{
                                opacity:
                                  filestatus.downloads_remaining === 0 ||
                                  filestatus.file_status.status ===
                                    'Cancelled' ||
                                  filestatus.file_status.status === 'Expired' ||
                                  filestatus.file_status.status === 'Restoring'
                                    ? 0.4
                                    : 1
                              }"
                              @click="downloadFile(filestatus, index)"
                              class="float-right mt-n2 download-icon"
                              src="../../assets/images/download.svg"
                              alt="download icon"
                            />
                          </v-btn>
                        </p>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-content>
    </v-container>
  </v-app>
</template>

<script>
import ErrorComponent from "../Receiver/ErrorComponent";
import moment from "moment";
import { format, parseISO } from "date-fns";
import Filters from "../../mixins.js";
import Header from "../Header/HeaderPage";
export default {
  components: {
    Header,
    ErrorComponent
  },
  data: () => ({
    downloadText: "Downloads Remaining",
    receiverFilesData: null,
    isButtonActive: false,
    downloadCount: null,
    btnColor: "pink",
    downloadParams: {
      IP_address: "10.234.35.197",
      hash_code: null
    }
  }),
  mounted() {
    let vm = this;
    let hashCode = "";
    if (this.$route.params.id) {
      hashCode = this.$route.params.id;
    }
    const domainUrl = `api/receiver/${hashCode}/`;
    vm.$apiService
      .getPublicData(domainUrl)
      .then(data => {
        if (data.data) {
          this.receiverFilesData = data.data;
          this.downloadParams.hash_code = data.data.hash_code;
          this.receiverFilesData.ordered_items.forEach((status, index) => {
            this.receiverFilesData.ordered_items[index][
              "disable_download"
            ] = false;
          });
        }
      })
      .catch(err => {
        if (err) {
          this.$router.push("/error");
        }
      });
    /* removed, As ip address is not required anymore
    vm.$apiService.getIPAddress().then(res => {
    this.downloadParams.IP_address = Crypto.set(res.data.ip);
    //--changed for encyption---  this.downloadParams.IP_address = res.data.ip;
    }); */
  },
  methods: {
    downloadFile(file, index) {
      this.receiverFilesData.ordered_items[index].disable_download = true;
      this.$forceUpdate();
      let vm = this;
      /*--this is get method --*/
      let hashCode = "";
      if (this.$route.params.id) {
        hashCode = this.$route.params.id;
      }
      const domainUrl2 = `api/receiver/${hashCode}/`;
      vm.$apiService
        .getPublicData(domainUrl2)
        .then(data => {
          if (data.data) {
            this.receiverFilesData = data.data;
            this.downloadParams.hash_code = data.data.hash_code;
            this.receiverFilesData.ordered_items.forEach((status, index) => {
              this.receiverFilesData.ordered_items[index][
                "disable_download"
              ] = false;
            });
          }
        })
        .catch(err => {
          if (err) {
            this.$router.push("/error");
          }
        });
      /*this is post method */
      let domainUrl1 = "api/receiver/download/";
      let data = {
        order_item_id: file.order_item_id,
        // removing becuase api doest need ip anymore IP_address: this.downloadParams.IP_address,
        hash_code: this.downloadParams.hash_code
      };
      vm.$apiService.postPublicData(`${domainUrl1}`, data).then(data => {
        if (data.data.error) {
          this.$swal({
            icon: "warning",
            confirmButtonText: "Ok",
            showCloseButton: true,
            text: data.data.error
          }).then(result => {
            console.log(data.data.error);
          });
        } else {
          let downloadUrl = data.data.s3_presigned_url;
          let downloadCount =
            this.receiverFilesData.ordered_items[index].downloads_remaining - 1;
          this.receiverFilesData.ordered_items[
            index
          ].downloads_remaining = downloadCount;
          if (downloadCount === 0) {
            this.receiverFilesData.ordered_items[index].file_status.status =
              "Max Limit reached";
            let status = "Max Limit Reached";
            this.getColor(status);
          }
          this.receiverFilesData.ordered_items[index].disable_download = false;
          this.$forceUpdate();
          window.open(downloadUrl);
        }
      });
    },
    getColor(status) {
      if (status === "Cancelled") return "#CB4A5F";
      else if (status === "Expired") return "#CB4A5F";
      else if (status === "Archived") return "#E89D42";
      else if (status === "Restoring") return "#E89D42";
      else if (status === "Max Limit Reached") return "#CB4A5F";
      else return "#80B336";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "ReceiverPage";
</style>

<style lang="scss">
@import "ReceiverPage_unscoped.scss";
</style>
